import React from 'react';
import DepOnlineForm from './DepOnlineForm';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { DEP_ONLINE_FORM } from './DepOnline.constants';
import { getFormValues } from 'redux-form';
import { loadingSelector, ReducerNames } from 'common';

const DepOnline: React.FC = () => {
  const { loading, formValues } = useSelector((state: AppState) => ({
    loading: loadingSelector(ReducerNames.DEP_ONLINE)(state),
    formValues: getFormValues(DEP_ONLINE_FORM)(state),
  }));

  return (
    <DepOnlineForm
      {...{
        loading,
        formValues,
        workaround: true,
      }}
    />
  );
};

export default DepOnline;
